import { Group, type GroupProps } from "@mantine/core"
import dayjs, { type ConfigType } from "dayjs"
import { icons } from ".."

interface IProps extends GroupProps {
  timestamp: ConfigType
  format?: string
  withIcon?: boolean
}

export function DateTime({ timestamp, format = "LT L", withIcon, ...props }: IProps) {
  if (!timestamp) return null

  const date = dayjs(timestamp)
  if (!date.isValid()) return null

  const base = <time dateTime={date.toISOString()}>{date.format(format)}</time>
  if (!withIcon) return base

  return (
    <Group justify="space-between" gap={0} wrap="nowrap" w={118} {...props}>
      <icons.Calendar />
      {base}
    </Group>
  )
}
